import * as React from 'react';
import ApplicationCard, { Props } from './application_card';
import { shallow, ShallowWrapper } from 'enzyme';
import applicationDummy from '__fixtures__/application_dummy';

const createTestProps = moreProps => {
  return {
    title: '',
    children: '',
    application: applicationDummy,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application Card component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationCard {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
